var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJcb = function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 18,
    fill: "none",
    viewBox: "0 0 28 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 .5h20A3.5 3.5 0 0 1 27.5 4v10a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 14V4A3.5 3.5 0 0 1 4 .5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E7EC",
    d: "M4 .5h20A3.5 3.5 0 0 1 27.5 4v10a3.5 3.5 0 0 1-3.5 3.5H4A3.5 3.5 0 0 1 .5 14V4A3.5 3.5 0 0 1 4 .5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jcb_svg__a)",
    d: "M129 82.5h10.5c.3 0 1-.1 1.3-.1 2-.4 3.7-2.2 3.7-4.7 0-2.4-1.7-4.2-3.7-4.7-.3-.1-.9-.1-1.3-.1H129z",
    transform: "matrix(.11 0 0 .11 3.86 1.21)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jcb_svg__c)",
    d: "M138.3 16.2c-10 0-18.2 8.1-18.2 18.2v18.9h25.7c.6 0 1.3 0 1.8.1 5.8.3 10.1 3.3 10.1 8.5 0 4.1-2.9 7.6-8.3 8.3v.2c5.9.4 10.4 3.7 10.4 8.8 0 5.5-5 9.1-11.6 9.1H120v37h26.7c10 0 18.2-8.1 18.2-18.2V16.2z",
    transform: "matrix(.11 0 0 .11 3.86 1.21)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jcb_svg__d)",
    d: "M143.2 63.1c0-2.4-1.7-4-3.7-4.3-.2 0-.7-.1-1-.1H129v8.8h9.5c.3 0 .9 0 1-.1 2-.3 3.7-1.9 3.7-4.3",
    transform: "matrix(.11 0 0 .11 3.86 1.21)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jcb_svg__e)",
    d: "M37.7 16.2c-10 0-18.2 8.1-18.2 18.2v44.9c5.1 2.5 10.4 4.1 15.7 4.1 6.3 0 9.7-3.8 9.7-9V53.2h15.6v21.1c0 8.2-5.1 14.9-22.4 14.9-10.5 0-18.7-2.3-18.7-2.3v38.3h26.7c10 0 18.2-8.1 18.2-18.2V16.2z",
    transform: "matrix(.11 0 0 .11 3.86 1.21)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#jcb_svg__f)",
    d: "M88 16.2c-10 0-18.2 8.1-18.2 18.2v23.8c4.6-3.9 12.6-6.4 25.5-5.8 6.9.3 14.3 2.2 14.3 2.2v7.7c-3.7-1.9-8.1-3.6-13.8-4-9.8-.7-15.7 4.1-15.7 12.5 0 8.5 5.9 13.3 15.7 12.5 5.7-.4 10.1-2.2 13.8-4V87s-7.3 1.9-14.3 2.2c-12.9.6-20.9-1.9-25.5-5.8v42h26.7c10 0 18.2-8.1 18.2-18.2v-91z",
    transform: "matrix(.11 0 0 .11 3.86 1.21)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40a737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cb531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#jcb_svg__g",
    id: "jcb_svg__a",
    x1: 120.083,
    x2: 165.021,
    y1: 77.712,
    y2: 77.712,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#jcb_svg__g",
    id: "jcb_svg__c",
    x1: 120.082,
    x2: 165.023,
    y1: 70.706,
    y2: 70.706,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#jcb_svg__g",
    id: "jcb_svg__d",
    x1: 120.082,
    x2: 165.021,
    y1: 63.087,
    y2: 63.087,
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_svg__e",
    x1: 19.479,
    x2: 65.112,
    y1: 70.706,
    y2: 70.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f286f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004e94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006fbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_svg__f",
    x1: 69.541,
    x2: 113.862,
    y1: 70.706,
    y2: 70.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c2c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#be1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#dc0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e60039"
  })))));
};
export default SvgJcb;